import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, ViewChild } from '@angular/core';
import { MdDialogRef } from '@angular/material';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { FormErrors } from 'app/shared/validators/generic-validators';
import { ActivityService } from 'app/shared/components/activity/activity.service';
import { Activity } from 'app/shared/components/activity/activity-details.model';

@Component({
  selector: 'addactivity',
  templateUrl: './add-activity.component.html',
  styleUrls: ['./add-activity.component.css']
})

export class AddActivityComponent {
  filteredSearchResults: any[] = [];
  query: string;
  entityId: number;
  searchValue: any;
  savingActivity = false;

  constructor(
    public dialogRef: MdDialogRef<any>,
    private activityService: ActivityService,
    private snackBarService: SnackBarService
  ) { }

  filterSearchResults(event) {
    this.query = event.query;
    this.activityService.getActivities(this.query)
      .subscribe(response => {
        if (response.flagResult) {
          const filteredSearchValues: any[] = [];
          for (const value of response.arrResult) {
            filteredSearchValues.push(
              {
                'id': value.id,
                'value': value.activity
              });
          }
          this.filteredSearchResults = filteredSearchValues;
        }
      },
      err => {
        this.callSnackBarService(err, '', MessageService.ACTIVITY_FAILURE);
      }
      );
  }

  addActivity(): void {
    this.savingActivity = true;
    const activity = new Activity();
    if (this.searchValue.id) {
      activity.activityId = this.searchValue.id;
      activity.activityValue = this.searchValue.value;
    } else {
      activity.activityValue = this.searchValue;
    }
    activity.organisationId = this.entityId;

    this.activityService.addActivity(activity)
      .subscribe(
      success => {
        this.savingActivity = false;
        if (success.flagResult) {
          this.dialogRef.close(activity);
        }
        this.callSnackBarService(success, MessageService.ADDED_ACTIVITY_SUCCESS, '');
      },
      err => {
        this.savingActivity = false;
        this.callSnackBarService(err, '', MessageService.ACTIVITY_FAILURE);
      });
  }

  callSnackBarService(response: any, successMsg: string, failureMsg: string) {
    this.snackBarService.showStatus(response, successMsg, failureMsg);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/activity/addactivity/add-activity.component.ts